export const dataAdapter = (codeInternal, price, quantity) => {
	return {
		items: [
			{
				code_internal: codeInternal,
				price: price,
				quantity: quantity,
			},
		],
	};
};
